import type { BillingProduct, OrganizationBilling, StripeSessionResponse } from './billing';

const MOCK_PRODUCT_ID = 'mock-monthly-growth';

export const MOCK_BILLING_PRODUCT: BillingProduct = {
    id: MOCK_PRODUCT_ID,
    code: 'monthly-growth',
    name: 'Growth',
    description: 'One monthly plan with a 7-day trial and per-source pricing.',
    isActive: true,
    capabilities: {
        publishing: true,
        insights: true,
        apiKeys: true,
        customerSupport: true
    },
    limits: {
        socialAccountsIncluded: 2,
        additionalSourcePriceUsd: 5,
        monthlyBasePriceUsd: 9
    }
};

export const MOCK_BILLING_PRODUCTS: BillingProduct[] = [MOCK_BILLING_PRODUCT];

export function createMockBillingState(organizationId: string): OrganizationBilling {
    return {
        organizationId,
        product: {
            ...MOCK_BILLING_PRODUCT,
            stripeMonthlyPriceId: 'price_mock_monthly_growth',
            stripeYearlyPriceId: null,
            createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
        },
        subscriptionId: null,
        subscriptionStatus: 'trialing',
        source: 'stripe',
        billingInterval: 'monthly',
        stripeCustomerId: 'cus_mock_visible_pre_subscription',
        stripeSubscriptionId: null,
        stripePriceId: 'price_mock_monthly_growth',
        currentPeriodStart: new Date().toISOString(),
        currentPeriodEnd: null,
        cancelAtPeriodEnd: false,
        canceledAt: null,
        trialEndsAt: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(),
        quantity: 2,
        hasActivePlatformAccess: true,
        capabilities: MOCK_BILLING_PRODUCT.capabilities,
        limits: {
            ...MOCK_BILLING_PRODUCT.limits,
            socialAccounts: 2
        }
    };
}

export function createMockCheckoutSession(successUrl: string): StripeSessionResponse {
    return {
        sessionId: 'cs_mock_checkout',
        url: successUrl
    };
}

export function createMockCustomerPortalSession(returnUrl: string): StripeSessionResponse {
    return {
        sessionId: 'bps_mock_portal',
        url: returnUrl
    };
}
